export default __webpack_public_path__ + "static/media/menu_icon01.f46a9bad.png";